import Vue from 'vue';
import VueCurrencyFilter from 'vue-currency-filter';
import HoneybadgerVue from '@honeybadger-io/vue';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';

Vue.config.productionTip = false;

Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false,
});

if (process.env.VUE_APP_HONEYBADGER_API_KEY) {
  Vue.use(HoneybadgerVue, {
    apiKey: process.env.VUE_APP_HONEYBADGER_API_KEY,
    environment: process.env.NODE_ENV,
  });

  Vue.config.errorHandler = (err) => {
    console.log(err);
    try {
      Vue.$honeybadger.notify(err);
    } catch (e) {
      console.log(e);
    }
  };
}

Vue.use(VueTelInput);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#bts-accounts-ui-signup');
